/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmp_404_TitleInputs */

const en_cmp_404_title = /** @type {(inputs: Cmp_404_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That comparison doesn't exist`)
};

const id_cmp_404_title = /** @type {(inputs: Cmp_404_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perbandingan itu belum ada`)
};

/**
* | output |
* | --- |
* | "That comparison doesn't exist" |
*
* @param {Cmp_404_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cmp_404_title = /** @type {((inputs?: Cmp_404_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmp_404_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cmp_404_title(inputs)
	return en_cmp_404_title(inputs)
});